import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yandex': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M153.1 315.8l-87.4 196.2h-63.7l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1-0.1-107.4 68-161.1 148.9-161.1h82.3v512h-55.1v-196.2h-45.8zM198.9 46.5h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4v-223.4z'
      }
    ]
  }
})
